<template>
  <v-list style="background: transparent; margin-top: 20px">
    <h6 class="mb-3">MÉTODO DE PAGAMENTO</h6>
    <v-list-item :class="{'method-selected' : selectedPaymentFormId === method.payment_form_id}"
                 :key="method.payment_form_id"
                 @click.prevent="onSelection(method)"
                 class="methods"
                 v-for="(method) in paymentForms"
    >
      <v-list-item-avatar class="method-icon">
        <i v-if="method.payment_form_id === 2" class="far fa-credit-card"></i>
        <i v-else-if="method.payment_form_id === 3" class="fas fa-credit-card"></i>
        <i v-else-if="method.payment_form_id === 4" class="fas fa-wallet"></i>
        <i v-else-if="method.payment_form_id === 5" class="fas fa-money-check"></i>
        <i v-else-if="method.payment_form_id === 11" class="fas fa-qrcode"></i>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="method-name">{{
          method.name === 'CARTEIRA' ? 'MEUS CRÉDITOS' : method.name
          }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>
<script>
export default {
  name: 'payment-form-list',
  props: {
    selectedPaymentFormId: null,
    paymentForms: {},
  },
  methods: {
    onSelection(paymentForm){
      this.$emit('onPaymentForm', paymentForm);
    }

  },
}
</script>
<style scoped>

h6 {
  font-size: 12px;
  font-family: Roboto-Light;
  color: #a8a8a8;
  margin: 0;
}

.input >>> .v-text-field__slot input {
  font-size: 18px;
  font-family: Roboto-Black;
  color: #000 !important;
  margin-top: 0;
}

.methods {
  background: transparent;
  padding: 2px 0;
  border: 2px solid transparent;
  border-radius: 4px;
}

.method-icon {
  margin: 0;
}

.method-icon i {
  color: #9b9b9b;
}

.method-name {
  font-size: 16px;
  font-family: Roboto-Black;
  color: #9b9b9b;
}

.method-selected {
  background: #f8f8f8;
  border: 2px solid #f5f5f5;
  color: #000;
}

.method-selected .method-name, .method-selected .method-icon i {
  color: #000;
}

@media only screen and (max-width: 500px) {
  .method-name {
    font-size: 14px;
    padding: 2px;
  }

}

</style>
